import { format, isSameDay, type Locale } from 'date-fns';
import { ko } from 'date-fns/locale';

interface DateFormatOptions {
  formatStr?: string;
  locale?: Locale;
}

export function formatDate(date: string, options?: DateFormatOptions) {
  const { formatStr = 'yyyy-MM-dd', locale = ko } = options || {
    formatStr: 'yyyy-MM-dd',
    locale: ko,
  };
  return format(new Date(date), formatStr, { locale });
}

export function formatDateTimeRange(
  format: string,
  startDateTime: string,
  endDateTime?: string,
): string {
  if (endDateTime) {
    return `${formatDate(startDateTime, { formatStr: format })} - ${formatDate(endDateTime, {
      formatStr: format,
    })}`;
  }

  return formatDate(startDateTime, { formatStr: format });
}

export function formatAdaptiveDateTimeRange(
  format: string,
  startDateTime: string,
  endDateTime?: string,
): string {
  if (!endDateTime) {
    return formatDate(startDateTime, { formatStr: format });
  }

  const startDate = new Date(startDateTime);
  const endDate = new Date(endDateTime);

  if (isSameDay(startDate, endDate)) {
    return `${formatDate(startDateTime, { formatStr: format })} - ${formatDate(endDateTime, {
      formatStr: 'HH:mm',
    })}`;
  }
  if (startDate.getFullYear() !== endDate.getFullYear()) {
    return `${formatDate(startDateTime, { formatStr: format })} - ${formatDate(endDateTime, {
      formatStr: 'yyyy년 M월 d일(E) HH:mm',
    })}`;
  } else {
    return `${formatDate(startDateTime, { formatStr: format })} - ${formatDate(endDateTime, {
      formatStr: 'M월 d일(E) HH:mm',
    })}`;
  }
}

export function formatJourneyDateLabel(departureTime: string, arrivalTime: string) {
  const departureDate = new Date(departureTime);
  const arrivalDate = new Date(arrivalTime);

  if (isSameDay(departureDate, arrivalDate)) {
    return `${formatDate(departureTime, { formatStr: 'yyyy년 M월 d일(E)' })}`;
  }

  if (departureDate.getFullYear() !== arrivalDate.getFullYear()) {
    return `${formatDate(departureTime, { formatStr: 'yyyy년 M월 d일(E)' })} - ${formatDate(
      arrivalTime,
      { formatStr: 'yyyy년 M월 d일(E)' },
    )}`;
  }

  return `${formatDate(departureTime, { formatStr: 'yyyy년 M월 d일(E)' })} - ${formatDate(
    arrivalTime,
    { formatStr: 'M월 d일(E)' },
  )}`;
}
